<div class="bg-cr-white border-b-[1px] border-zinc-300">
  <!-- <div routerLink="/">
    <img
      width="200"
      height="68"
      src="/assets/img/logo.1643a230.svg"
      alt="College Recon"
    />
  </div> -->

  @if (pathname == 'media' || pathname.includes('pay-calculator')) {
    <app-menu [items]="emptyItems"></app-menu>
  } @else {
    <app-menu [items]="items"></app-menu>
  }
</div>
